import type { FieldHtmlNameType } from '@onshape/www-inertia';
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import GatedContentProgressiveProfileDefinition from './GatedContentProgressiveProfileDefinition';

/** Defines that fields to show, the name of the branch to consider and hide/show rules */
export default class PhoneGatedContentProgressiveProfileDefinition extends GatedContentProgressiveProfileDefinition {
  public override getAlwaysShownFields(): readonly FieldHtmlNameType[] {
    const alwaysShow = [...super.getAlwaysShownFields(), FieldHtmlNameUtil.phoneNumber];

    return alwaysShow;
  }
}
